import React from 'react';
import './Strikeout.css'; // create this stylesheet


function Strikeout() {
  return (
    <div className="strikeout-page">
      <div className="method-explanation">
      <h1>in the words of Taylor Swift! someday i'll be living in a big ol city and all you're ever going to be is mean </h1>
      <div className="subtitle-explanation">

      <h1>but seriously you're rude and your goal is to make people feel smaller,. that's pathetic </h1>
</div>
      </div>
    </div>
  );
}

export default Strikeout;